"use client";

import { c as _c } from "react/compiler-runtime";
import { ActivityFeed } from "./ActivityFeed";
import { ActivityFeedColumnsProvider } from "./ActivityFeedColumnsProvider";
import { ActivityFeedTableSkeleton } from "./ActivityFeedTableSkeleton";
import { useActivityFeedColumnDelta } from "./hooks";
export function ActivityFeedSkeleton(t0) {
  const $ = _c(8);
  let columns;
  let rest;
  if ($[0] !== t0) {
    ({
      columns,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = columns;
    $[2] = rest;
  } else {
    columns = $[1];
    rest = $[2];
  }
  const columnMap = useActivityFeedColumnDelta(columns);
  let t1;
  if ($[3] !== rest) {
    t1 = <ActivityFeed><ActivityFeedTableSkeleton {...rest} /></ActivityFeed>;
    $[3] = rest;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== columnMap || $[6] !== t1) {
    t2 = <ActivityFeedColumnsProvider columns={columnMap}>{t1}</ActivityFeedColumnsProvider>;
    $[5] = columnMap;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}